// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__centuryGothic_b532e8', '__centuryGothic_Fallback_b532e8'"},"className":"__className_b532e8","variable":"__variable_b532e8"};